import React from "react";
import { Button } from "lib/components";

export function ReturnHomeButton(props)
{
  return <Button caption="Return to List View" look="primaryFilled2" navigateTo="/" />
}